import { Link as ChakraLink, type LinkProps } from '@chakra-ui/react'
import React from 'react'

const NoteLink: React.FC<LinkProps> = ({ children, ...rest }) => {
  return (
    <ChakraLink variant="stickyNote" {...rest}>
      {children}
      <span className="bend" />
    </ChakraLink>
  )
}

export default NoteLink
